
export enum EditorFileProtocol {
  FILE  = 'file:',
  BIF   = 'bif:',
  ERF   = 'erf:',
  MOD   = 'mod:',
  RIM   = 'rim:',
  ZIP   = 'zip:',
  _7ZIP = '7zip:',
}
